import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { EmailNotificationState } from '../types';
import { emailNotificationState } from './emailNotificationState';

export const emailNotificationSlice = createSlice({
  name: 'emailNotifications',
  initialState: emailNotificationState,
  reducers: {
    setEmailNotifications(
      state,
      action: PayloadAction<EmailNotificationState['emailNotifications']>,
    ) {
      state.emailNotifications = action.payload;
    },
    setTotalRecordCounts: (state, action: PayloadAction<number>) => {
      state.totalRecordCount = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.pageIndex = action.payload;
    },
    setSortBy: (state, action: PayloadAction<string>) => {
      state.sortBy = action.payload;
    },
    setSortField: (state, action: PayloadAction<string>) => {
      state.sortField = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setFromDate: (state, action: PayloadAction<string>) => {
      state.fromDate = action.payload;
    },
    setToDate: (state, action: PayloadAction<string>) => {
      state.toDate = action.payload;
    },
    setResetData: () => emailNotificationState,
  },
});

export const { actions: emailNotificationActions } = emailNotificationSlice;

export const selectEmailNotifications = (state: RootState) =>
  state.emailNotifications;

export const selectEmailNotificationState = createSelector(
  selectEmailNotifications,
  emailNotifications => emailNotifications.emailNotifications,
);

export const selectTotalRecordCount = createSelector(
  selectEmailNotifications,
  emailNotifications => emailNotifications.totalRecordCount,
);

export const selectLimit = createSelector(
  selectEmailNotifications,
  emailNotifications => emailNotifications.limit,
);

export const selectPageIndex = createSelector(
  selectEmailNotifications,
  emailNotifications => emailNotifications.pageIndex,
);

export const selectSortBy = createSelector(
  selectEmailNotifications,
  emailNotifications => emailNotifications.sortBy,
);

export const selectSortField = createSelector(
  selectEmailNotifications,
  emailNotifications => emailNotifications.sortField,
);

export const selectSearch = createSelector(
  selectEmailNotifications,
  emailNotifications => emailNotifications.search,
);

export const selectFromDate = createSelector(
  selectEmailNotifications,
  emailNotifications => emailNotifications.fromDate,
);

export const selectToDate = createSelector(
  selectEmailNotifications,
  emailNotifications => emailNotifications.toDate,
);

export default emailNotificationSlice.reducer;
